<!--
    描述：业务模板页面
    时间：2020-05-19
    Created by yefan
-->
<template>
	<div class="basic-template-main w-tabs-layout">
		<el-tabs v-model="activeName"
				 @tab-click="handleClick">
			<el-tab-pane label="六算基本信息"
						 name="sixBasicInfo">
				<sixBasicInfo ref="sixBasicInfo"
							  v-if="activeName === 'sixBasicInfo'"
							  @leadTemplate="openTemplateDialog"></sixBasicInfo>
			</el-tab-pane>
			<el-tab-pane label="项目结构"
						 name="projectStructure">
				<projectStructureInfo ref="projectStructure"
									  v-if="activeName === 'projectStructure'"
									  @leadTemplate="openTemplateDialog"></projectStructureInfo>
			</el-tab-pane>
			<el-tab-pane label="建设项目结构"
						 name="projectStructureNew">
				<projectStructureInfoNew ref="projectStructureNew"
										 v-if="activeName === 'projectStructureNew'"
										 @leadTemplate="openTemplateDialog"></projectStructureInfoNew>
			</el-tab-pane>
			<!--			<el-tab-pane label="指标分析"
						 name="indexAnalysis">
				<indexAnalysisInfo ref="indexAnalysis"
								   v-if="activeName === 'indexAnalysis'"></indexAnalysisInfo>
			</el-tab-pane>-->
		</el-tabs>

		<!-- 导入模板弹窗 -->
		<el-dialog :before-close='dialogClose'
				   class='custom-dialog'
				   top='7vh'
				   :close-on-click-modal='false'
				   :destory-on-close='true'
				   :title='dialogObj.title'
				   :visible.sync='dialogObj.show'
				   width='800px'>
			<el-form :model="temForm"
					 ref="temForm"
					 class="mt20"
					 label-width="120px"
					 :show-message="false">
				<el-form-item label="应用类型"
							  prop="typeName"
							  required>
					<el-select size="small"
							   v-model="temForm.typeName"
							   clearable>
						<el-option v-for="(item, index) in templateList"
								   :key="'project' + index"
								   :label="item.sname"
								   :value="item.sname"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="文件"
							  required>
					<my-upload :aid="aid"
							   mode="add"
							   ref="myUpload"
							   :multiple="false"
							   :maxNum="1"
							   :acceptType="['xls', 'xlsx']"></my-upload>
				</el-form-item>
			</el-form>
			<div slot='footer'
				 class="text-center">
				<el-button @click='dialogClose'>取 消</el-button>
				<el-button type='primary'
						   @click='dialogSubmit'
						   :loading='dialogObj.loading'>确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import sixBasicInfo from './six_basic_info'
import indexAnalysisInfo from './index_analysis_info'
import projectStructureInfo from './project_structure_info'
import projectStructureInfoNew from './project_structure_info_new'
import { getNewTypeList, saveExcelTemplate } from '@/api/modules/analysis.js'
import myUpload from 'components/upload/upload'

export default {
	name: 'Business_template',
	components: {
		sixBasicInfo,
		indexAnalysisInfo,
		projectStructureInfo,
		projectStructureInfoNew,
		myUpload,
	},
	data() {
		return {
			activeName: 'sixBasicInfo',
			dialogObj: {
				title: '导入模板',
				show: false,
				loading: false,
			},
			temForm: { typeName: '', type: '' },
			templateList: [],
			aid: '',
		}
	},
	created() {
		// 初始 tabName
		this.setActiveName()
	},
	methods: {
		// 切换tab 的事件
		handleClick(tab) {
			let type = null

			switch (this.activeName) {
				case 'sixBasicInfo':
					type = 1
					break
				case 'projectStructure':
					type = 2
					break
				case 'projectStructureNew':
					type = 3
					break
				default:
					return
			}

			this.$router.push({
				// name: 'Business-template',
				query: {
					type: type,
				},
			})
		},

		// 初始 tabName
		setActiveName() {
			switch (parseInt(this.curType)) {
				case 1:
					this.activeName = 'sixBasicInfo'
					break
				case 2:
					this.activeName = 'projectStructure'
					break
				case 3:
					this.activeName = 'projectStructureNew'
					break
				default:
					this.activeName = 'sixBasicInfo'
					return
			}
		},

		// 模板应用类型下拉选等 集合
		getSelectedList() {
			getNewTypeList({}).then((res) => {
				this.templateList = res.data.applyTypes
			})
		},

		// 导入模板
		openTemplateDialog(data) {
			this.dialogObj.show = true
			this.temForm.type = data.type
			this.getSelectedList()
		},

		// 弹窗确认
		dialogSubmit() {
			this.dialogObj.loading = true
			this.$refs.temForm.validate((valid) => {
				if (valid) {
					let _addList = this.$refs.myUpload.addList
					if (_addList.length === 0) {
						this.$message.warning('请上传具体的文件!')
						this.dialogObj.loading = false
						return
					}
					let formData = new FormData()
					for (let item of _addList) {
						formData.append('file', item)
					}
					formData.append('type', this.temForm.type)
					formData.append('typeName', this.temForm.typeName)
					saveExcelTemplate(formData)
						.then((res) => {
							this.$refs[this.activeName].getTablePageList()
							this.dialogClose()
						})
						.finally((err) => {
							this.dialogObj.loading = false
						})
					return
				}
				this.dialogObj.loading = false
				this.$message.error('请完善表单')
			})
		},

		// 弹窗关闭
		dialogClose() {
			this.dialogObj = {
				title: '导入模板',
				show: false,
				loading: false,
				type: '',
			}
			this.temForm = { type: '', typeName: '' }
		},
	},
	computed: {
		// 当前类型 1 为六算基本信息  2 为项目结构  3为建设项目结构
		curType() {
			return this.$route.query.type
		},
	},
}
</script>


<style lang="less" scoped>
.basic-template-main {
	height: 100%;
	background-color: #fff;
	padding: 0 10px;
}
</style>
